import { PutCsvExcelAccountsApi } from "@/features/accounts/csv-excel/services/put-accounts-api";
import { PutCsvExcelAccountsRequestModel } from "@/features/accounts/csv-excel/services/put-accounts-model";

/// CsvExcel更新処理
export class PutCsvExcelAccountsService {
  private putCsvExcelAccountsApi = new PutCsvExcelAccountsApi();

  /**
   * CsvExcel更新API実行
   */
  public async putCsvExcelAccounts(param: PutCsvExcelAccountsRequestModel) {
    return await this.putCsvExcelAccountsApi.putCsvExcelAccounts(param);
  }
}
